export { default as RawPicture } from './raw-picture';
